<div mat-dialog-content>
    <div *ngFor="let iList of flight.FlightDetails.Details" class="row">
        <div class="col-md-12">
            <div class="card pb-0 mb-2">
                <div class="card-body pb-0">
                    <div *ngFor="let list of iList; let i = index">
                        <div class="row d-none">
                            <div class="row col-md-12 m-0 p-0 bbottom" *ngIf="list.LayOverTime">
                                <div class="col-md-3 text-danger customDetailsCenter">
                                    <i class="pe-7s-clock f-20 font-weight-bold"></i>
                                    <span class="f-12">
                                        {{list.LayOverTime}}
                                    </span>
                                </div>
                                <div class="col-md-9 m-0 pr-0 rounded-0 alert alert-danger" role="alert">
                                    <div class="d-flex flex-column text-muted">
                                        <div class="my-2 text-dark">
                                            {{ 'Layover in ' + list.Origin.CityName + '(' + list.Origin.AirportCode +
                                            ')' }}
                                            {{' '+ list.LayOverTime}}
                                        </div>
                                        <div class="text-danger">
                                            <span>
                                                - A transit visa may be required
                                            </span>
                                        </div>
                                        <div class="text-danger">
                                            <span>
                                                - Baggage can be checked through
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row pb-3 pt-3 bbottom">
                            <div class="col-md-3 col-12 pr-0 customDetailsCenter">
                                <div class="">
                                    <img width="30" class="rounded"
                                        style="padding-top: 5px; width: 95px; padding-bottom: 5px;"
                                        [src]="[airline_logo + list.OperatorCode + '.svg']" alt="">
                                    <span>
                                        <div style="line-height:normal;">
                                            <div class="deemFont">
                                                <small> {{ list.OperatorName + ' (' + list.OperatorCode + ')' }}</small>
                                            </div>
                                            <div class="">
                                                <small> {{ 'Flight Number :'+' '+list.FlightNumber }}</small>
                                            </div>
                                            <div class="">
                                                <small> {{'Cabin Class :'+' '+ list.CabinClass }}</small>
                                            </div>
                                            <div class="">
                                                <small> {{'Aircraft :'+' '+ list.Equipment }}</small>
                                            </div>
                                        </div>
                                    </span>
                                </div>
                            </div>
                            <div class="col-md-3 col-6 pr-0 text-center mobile_left customDetailsCenter">
                                <div class="">
                                    <div class="timesFont">
                                        <strong style="color: #082b3a;">{{list.Origin.AirportCode}}</strong> {{list.Origin.DateTime | date: 'HH:mm'}}
                                    </div>
                                    <div class="">
                                        {{list.Origin.DateTime | date:'EE, d MMM y'}}
                                    </div>
                                    <div class="">
                                        {{list.Origin.AirportName}}
                                    </div>
                                    <div class="" *ngIf="list.Origin.Terminal">
                                        Terminal : {{list.Origin.Terminal ? list.Origin.Terminal : ''}}
                                    </div>
                                </div>
                            </div>
                            <div
                                class="col-md-3 col-6 pr-0 padding_right_mobile text-center mobile_right customDetailsCenter">
                                <div class="">
                                    <div class="timesFont">
                                        <strong style="color: #082b3a;">{{list.Destination.AirportCode}}</strong> {{list.Destination.DateTime | date: 'HH:mm'}}
                                    </div>
                                    <div class="">
                                        {{list.Destination.DateTime | date:'EE, d MMM y'}}
                                    </div>
                                    <div class="">
                                        {{list.Destination.AirportName}}
                                    </div>
                                    <div class="" *ngIf="list.Destination.Terminal">
                                        Terminal : {{list.Destination.Terminal}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3 col-12 pr-0 text-right mobile_left customDetailsCenter">
                                <div class="text-right mobile_left" style="padding-right: 15px !important;">
                                    <div class="">{{list.Duration}}</div>
                                    <div class="">Stop: {{i}}</div>
                                    <div class="text-muted">
                                        <i class="fa fa-wheelchair"></i>
                                        <i> {{ list.Attr.AvailableSeats }} </i>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="(list?.LayoverTime)"  class="layovertime">Layover Time : {{list?.LayoverTime}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>